<template>
  <v-card
  class="mb-5"
  max-width="400"

  >
  <v-card-title>{{prodotto.nome}}</v-card-title>
  <v-card-subtitle>{{prodotto.descrizione}}</v-card-subtitle>
  <v-card-text>

    <div class="prodotto-opzioni">

      <v-chip v-if="prodotto.giorni" class="prodotto-opzione prodot-giorni">giorni: <strong>{{prodotto.giorni}}</strong></v-chip>

    </div>
    <div v-if="prodotto.prezzo" class="my-4 subtitle-1">
      <span class="euro">&euro;</span> {{valuta(prezzo)}}
      <span class="prodotto-iva">({{valuta(netto)}} + IVA &euro;{{valuta(iva)}})</span>
     </div>
     <div v-if="!prodotto.prezzo" class="my-4 subtitle-1">
       <div class="euro">Gratuito</div>
     </div>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="open(prodotto)" block large color="primary">
      <span v-if="!prodotto.prezzo">Ottieni</span>
      <span v-else >Acquista</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import menu from "@mixins/menu.js"
import version from "@mixins/version.js"
import env from "@mixins/environment.js"
import MSPFormatter from "@shared/msp/formatter.js";

const component = {
  props: [
    'prodotto',
  ],
  computed: {
    netto ()
    {
      const netto = MSPFormatter.arrotonda(this.prezzo / (1+this.aliquota), 2);
      return netto;
    },
    prezzo ()
    {
      const prezzo = MSPFormatter.arrotonda(+this.prodotto.prezzo, 2);
      return prezzo;
    },
    aliquota ()
    {
      const aliquota = MSPFormatter.arrotonda(+this.prodotto.iva/100, 2);
      return aliquota;
    },
    iva ()
    {
      const iva = MSPFormatter.arrotonda(this.prezzo - this.netto, 2);
      return iva;
    }
  },
  mixins: [
    env,
    menu,
    version,
  ],
  methods: {
    valuta (prezzo)
    {
      return MSPFormatter.valuta(prezzo);
    },
    open (prodotto)
    {
      this.$router.push({name: 'checkout', query: {prodotto: prodotto.id}});
    }
  }
}

export default component;
</script>
<style lang="scss">
.prodotto {

  .v-card__title {
    word-break: normal;
  }
  .v-btn__content {
    flex-direction: column;
    white-space: wrap;
  }
  .prodotto-iva {
    font-size: 0.9em;
  }
}
</style>
